<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll('id')"
    @check-none="checkNone('id')"
    @set-selected-row="setSelectedRow($event, 'id')"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  >
    <template slot="color" slot-scope="{ item }">
      <span class="state-color-cell" v-if="item.color">
        <span
          class="state-color-cell__chip"
          :style="{ backgroundColor: item.color }"
          :title="item.color"
          aria-hidden="true"
        ></span>
        <span class="state-color-cell__hex">{{ String(item.color).toLowerCase() }}</span>
      </span>
      <span v-else class="state-color-cell state-color-cell--empty">
        <span class="state-color-cell__chip state-color-cell__chip--empty" aria-hidden="true"></span>
        <span class="state-color-cell__hex text-muted">—</span>
      </span>
    </template>
    <template slot="is_final" slot-scope="{ item }">
      <i v-if="item.is_final" class="fas fa-check text-success" :title="$t('Yes')" aria-hidden="true"></i>
      <i v-else class="fas fa-times text-muted" :title="$t('No')" aria-hidden="true"></i>
    </template>
    <template slot="ordering" slot-scope="{ item }">
      <span>{{ item.ordering != null ? item.ordering : '' }}</span>
    </template>
  </thux-table>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as TASK_STATE_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'TaskStateTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        { key: 'checks', label: this.$t('Checks') },
        { key: 'status', label: this.$t('Status'), tdClass: 'text-nowrap', thClass: 'text-nowrap', sortable: true, value: 'status' },
        { key: 'code', label: this.$t('Code'), type: 'text', thClass: 'text-nowrap', tdClass: 'text-nowrap', sortable: true, value: 'code' },
        { key: 'name', label: this.$t('Name'), type: 'text', thClass: 'text-nowrap', tdClass: 'text-nowrap', sortable: true, value: 'name' },
        { key: 'color', label: this.$t('Color'), custom: true, thClass: 'text-nowrap', tdClass: 'text-nowrap', sortable: false, value: 'color' },
        { key: 'is_final', label: this.$t('Is final'), custom: true, tdClass: 'text-center', thClass: 'text-center', sortable: true, value: 'is_final' },
        { key: 'ordering', label: this.$t('Ordering'), custom: true, tdClass: 'text-nowrap', thClass: 'text-nowrap', sortable: true, value: 'ordering' },
        { key: 'action', label: this.$t('Actions'), tdClass: 'text-right text-nowrap', thClass: 'text-right text-nowrap' }
      ],
      fieldsColumn: ['status', 'code', 'name', 'color', 'is_final', 'ordering'],
      fieldName: 'id'
    }
  },
  computed: {
    ...mapGetters({
      selectAll: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.GETTERS.selectAll,
      selectedList: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('tasks_taskstate_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.MUTATIONS.setList,
      setSelectedList: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.MUTATIONS.setSelectedList,
      setSelectAll: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.ACTIONS
    })
  }
}
</script>
